<div class="contents" [ngClass]="{hidden: (tabs['edition'].length > 0)}">
  <gs-access-router-outlet />
</div>
<gs-tabs-host-edition #tabsHostEdition
                      [className]="true || tabsHostEdition?.maximized ? 'maximized' : 'windowed'"
></gs-tabs-host-edition>
